<template>
    <div><!-- 訂單查詢 -->
        <CCard>
            <CCardBody>
                <div class="d-flex justify-content-between">
                    <button class="btn btn-success mb-2" v-if="!isEmployee" :disabled="disableConfirm" @click="orderConfirmEvent">{{i18n('Buttons.Confirm')}}</button>
                    <div v-if="isEmployee"> </div>
                    <div>
                        <button class="btn btn-edit mb-2 mr-2" @click="orderPrintEvent">{{i18n('Buttons.Print')}}</button>
                        <router-link class="btn btn-dark mb-2" @click.native="goBackEvent" to="">{{i18n('Buttons.GoBack')}}</router-link>
                    </div>
                </div>
                <div class="info">
                    <div class="info_col">
                        <p>{{i18n('DocumentQueryInfo.PurchasingDocument')}}: {{orderDetailRow.bsart + '-' + orderDetailRow.ebeln}}</p>
                        <p>{{i18n('DocumentQueryInfo.VendorCode')}}: {{orderDetailRow.lifnr}}</p>
                        <p>{{i18n('DocumentQueryInfo.GoodsSupplierCode')}}: {{orderDetailRow.gsLifnr}}</p>
                        <p>{{i18n('DocumentQueryInfo.Currency')}}: {{orderDetailRow.waers}}</p>
                        <p>{{i18n('DocumentQueryInfo.Incoterms')}}: {{orderDetailRow.inco1}}  {{orderDetailRow.inco2}}</p>
                        <!-- <p><span class="bg-yellow">{{i18n('DocumentQueryInfo.BillAddress')}}:</span>{{orderDetailRow.billTo}}</p>
                        <p><span class="bg-yellow">{{i18n('DocumentQueryInfo.DeliveryAddress')}}:</span>{{orderDetailRow.shipTo}}</p>
                        <p v-for="(it, index) in getRemarkList()" :key="'remark_'+index">{{getRemarkItemTxt(it,index)}}</p>                         -->
                    </div>
                    <div class="info_col">
                        <p>{{i18n('DocumentQueryInfo.DocumentVersion')}}: {{orderDetailRow.zzebver}}</p>
                        <p>{{i18n('DocumentQueryInfo.Vendor')}}: {{orderDetailRow.customerName}}</p>
                        <p>{{i18n('DocumentQueryInfo.GoodsSupplier')}}: {{orderDetailRow.gsLifnrName1}}</p>
                        <p>{{i18n('DocumentQueryInfo.TermsOfPaymnt')}}: {{orderDetailRow.ztermTxt}}</p>
                        <p>{{i18n('DocumentQueryInfo.ShippingMethod')}}: {{orderDetailRow.expvzTxt}}</p>
                    </div>
                    <div class="info_col">
                        <p>{{i18n('DocumentQueryInfo.DocumentDate')}}: {{fixDate(orderDetailRow.aedat)}}</p>
                        <p>{{i18n('DocumentQueryInfo.DocumentReleaseDate')}}: {{fixDate(orderDetailRow.supDate)}}</p>
                        <p>{{i18n('DocumentQueryInfo.VendorConfirm')}}: {{fixConfirmTime(orderDetailRow.confirmTime)}}</p>
                        <p>{{i18n('DocumentQueryInfo.VendorConfirmData')}}: {{fixDate(orderDetailRow.confirmTime)}}</p>
                        <p>{{i18n('DocumentQueryInfo.PurchaseGroup')}}: {{orderDetailRow.ekgrpTxt}}</p>
                    </div>
                </div>
                <div class="address">
                    <p><span>{{i18n('DocumentQueryInfo.BillAddress')}}:</span>{{orderDetailRow.billTo}}</p>
                    <p><span>{{i18n('DocumentQueryInfo.DeliveryAddress')}}:</span>{{orderDetailRow.shipTo}}</p>
                    <p v-for="(it, index) in getRemarkList()" :key="'remark_'+index">{{getRemarkItemTxt(it,index)}}</p>  
                </div>             
                <!-- PO -->
                <table class="table" v-if="isPOType">
                    <thead class="thead-light">
                        <tr>
                            <th class="align-top">{{i18n('DocumentQueryInfo.No')}}</th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.Material')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.ShortText')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.Specification')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.MaterialVersion')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.Unit')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.TaxCode')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.DeliveryData')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.CustomerMaterialNumber')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.ProductDrawingNumber')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.POQuantity')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.NetPrice')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.NetAmount')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.CaseClosed')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.PurchaseRequity')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.Requistitioner')}}</span> <br>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="dashed" v-for="(item ,index) in orderDetailRow.tbSupPoDtlList" :key="'tbSupPoDtlList_'+ index">
                            <td class="reply">
                                {{fixNumber(item.ebelp)}}      
                                <p class="test">{{i18n('DocumentQueryInfo.ItemText')}}：{{item.remark}}</p>                          
                            </td>
                            <td class="align-top">
                                <span>{{item.matnr}}</span> <br>
                                <span>{{item.txz01}}</span> <br>
                                <span>{{item.groes}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{item.revlv}}</span> <br>
                                <span>{{item.meins}}</span> <br>
                                <span>{{item.mwskz}}: {{item.taxRate | currencyF2}}%</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{fixDate(item.eindt)}}</span> <br>
                                <span>{{item.bismt}}</span> <br>
                                <span>{{item.zeinr}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{item.menge | currencyF3}}</span> <br>
                                <span>{{item.netpr | currencyF5}}</span> <br>
                                <span>{{item.netwr | currencyF2}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{fixZclose(item.zclose)}}</span> <br>
                                <span>{{item.banfn}}</span> <br>
                                <span>{{item.afnamName}}</span> <br>
                            </td>
                        </tr>                        
                    </tbody>
                </table>
                <!-- SAG -->
                <table class="table mb-4" v-if="!isPOType">
                    <thead class="thead-light">
                        <tr>
                            <th class="align-top">{{i18n('DocumentQueryInfo.No')}}</th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.Material')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.ShortText')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.Specification')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.MaterialVersion')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.Unit')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.TaxCode')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.NetPrice')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.CustomerMaterialNumber')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.ProductDrawingNumber')}}</span> <br>
                            </th>
                            <th class="align-top">
                                <span>{{i18n('DocumentQueryInfo.CaseClosed')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.PurchaseRequity')}}</span> <br>
                                <span>{{i18n('DocumentQueryInfo.Requistitioner')}}</span> <br>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="dashed" v-for="(item ,index) in orderDetailRow.tbSupPoDtlList" :key="'tbSupPoDtlList_'+ index">                        
                            <td class="reply">
                                 {{fixNumber(item.ebelp)}}      
                                <p class="test">{{i18n('DocumentQueryInfo.ItemText')}}：{{item.remark}}</p>                                
                            </td>
                            <td class="align-top">
                                <span>{{item.matnr}}</span> <br>
                                <span>{{item.txz01}}</span> <br>
                                <span>{{item.groes}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{item.revlv}}</span> <br>
                                <span>{{item.meins}}</span> <br>
                                <span>{{item.mwskz}}: {{item.taxRate | currencyF2}}%</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{item.netpr | currencyF5}}</span> <br>
                                <span>{{item.bismt}}</span> <br>
                                <span>{{item.zeinr}}</span> <br>
                            </td>
                            <td class="align-top">
                                <span>{{fixZclose(item.zclose)}}</span> <br>
                                <span>{{item.banfn}}</span> <br>
                                <span>{{item.afnamName}}</span> <br>
                            </td>
                        </tr>                                              
                    </tbody>
                </table>
                <div class="money">
                    <div class="money-container">
                        <p>{{i18n('DocumentQueryInfo.NetAmount')}}:</p>
                        <p>{{i18n('DocumentQueryInfo.Tax')}}:</p>
                        <p>{{i18n('DocumentQueryInfo.Tax-includedAmount')}}:</p>
                    </div>
                    <div class="money-container">
                        <p>{{orderDetailRow.untaxTtlAmt | currencyF2}}</p>
                        <p>{{orderDetailRow.taxAmt | currencyF2}}</p>
                        <p>{{(orderDetailRow.untaxTtlAmt+orderDetailRow.taxAmt) | currencyF2}}</p>
                    </div>            
                </div>
                <div class="clause mt-2" v-html="provision">                                   
                </div>
            </CCardBody>
        </CCard>        
    </div>
</template>
<script>
import { orderMixin } from '@/mixin/order'
export default {
    mixins: [orderMixin],
    data() {
        return {  
            proid : '',
            searchType: 'Order',
            PhraseKind_04: [] ,
            TwProvision : '',
            EnProvision : '',
            provision : ''
        }
    },
    props : {
    },
    watch :{
        isTw:function(v) {
            if(v){
                this.provision = this.TwProvision;
            }else{
                this.provision = this.EnProvision;
            }
        }
    },
    methods: {
        goBackEvent (){
            //判斷供應商且尚未按下確認功能
            if(!this.isEmployee && !this.disableConfirm){
                this.$confirm('若您尚未點選訂單上的[確認]鈕後，請點選[確認]再離開，謝謝！是否離開目前的網頁？', '提示', {
                    confirmButtonText: '是',
                    cancelButtonText: '否',
                    type: 'warning'
                }).then(() => {
                    this.$router.push('ordersearch');
                }).catch(() => {
                    //console.log("放棄了");
                });
                return;
            }
            this.$router.push('ordersearch');
        },
        orderConfirmEvent (){ //訂單確認
            const url = `${this.$apiUrl_Order}/OrderConfirm`
            const param = {proid : this.proid};
            this.updateLoading(true);
            this.axios.post(url, param).then((response) => {
                const {status , statusMessage} = response.data;
                this.updateLoading(false);
                if(status){
                    this.$alert(statusMessage,'警告',{type: 'warning'});
                }else{
                    //--成功          
                    this.orderDetailRow.confirmTime = new Date().yyyymmdd();
                    this.$alert('訂單確認完成','訊息',{});
                }                    
            });
        },
        orderPrintEvent (){ //訂單列印
            let url = `${this.$apiUrl_Print}/PrintOrderDetail/${this.proid}`;
            this.openNewTabByALink('orderPrint',url);
        },
        getRemarkList (){
            const rt = this.reBuildRemarkList(this.orderDetailRow);            
            return rt;
        },        
        getProvisionData (){
            
        }
    },
    computed: {
        isPOType (){
            const {orderDetailRow} = this;
            //L 為 SAG，F 為 PO
            if(orderDetailRow && orderDetailRow.bstyp === 'L'){
                return false;
            }
            return true;
        },
        isEmployee() {            
            return this.$store.state.isEmployee;            
        },
        disableConfirm (){
            if(this.orderDetailRow && this.orderDetailRow.confirmTime){
                return true;
            }
            return false;
        }
    },
    mounted() {  
        const self = this;         
        let orderId = sessionStorage.getItem('orderId');              
        if(orderId) {
            this.proid = orderId;
            this.getOrderDetail(orderId);
        } else{
            this.$router.push('ordersearch');
        }
        this.$store.dispatch('getPhraseKind_04',{}).then((data) => {
           this.PhraseKind_04 = data;     
           if(data && data.length >0){
               data.forEach(item => {
                   if(item.phraseNo === 1){
                      self.TwProvision = item.memo;
                   }else if(item.phraseNo === 2){
                      self.EnProvision = item.memo;
                   }
               });           
               if(self.isTw){
                    self.provision = self.TwProvision;
               }else{
                    self.provision = self.EnProvision;
               }
           }
        }); 
    }
}
</script>
<style lang="scss" scoped>
table th:first-child {
    text-align: center;
    padding: 15px 5px;
}

.table td {
    border: none;
    margin-bottom: 5rem;
}

.table tr:nth-child(even) {
    background-color: transparent;
}

.info {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border: 1px solid #ececec;
    border-bottom: none;
    padding-top: 1rem;
}
.info_col {
    display: flex;
    flex-direction: column;

    > p {
        margin-left: 1rem;
        margin-right: 1rem;
    }
}

.dashed {
    border-bottom: none;
    border-bottom: 2px dashed;
}

.reply {
    display: flex;
    flex-direction: column;
    border: none;
    position: relative;
    
    .btn {
        margin-top: 4rem;
    }
}

.money {
    display: flex;
    // flex-direction: column;
    // align-items: flex-end;
    justify-content: flex-end;
    margin-top: 6rem;
    margin-right: 8rem;
    .money-col {
        display: flex;
    }

    .money-container {
        text-align: right;
    }

    .money-container:first-child {
        margin-right: 1rem;
    }
}

.btn-edit {
    background-color: #343b55;
    color: white;
}

.clause-mt {
    margin-top: 6rem;
}

.clause {
    font-size: 12px;
}
.clause {
    font-size: 12px;
}

.clause::v-deep .title {
        font-size: 1rem;
        font-weight: bolder;
        margin-bottom: 1rem;
    }

.content {
    border-bottom: 2px dashed;
}

.test {
    position: absolute;
    left: 0;
    margin-top: 5rem;
    overflow: hidden;
    word-break: keep-all;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 1050px;
}
.bg-yellow {
    background-color: #FFFF00 !important;
    color:#000;
    font-weight: 900;
}

.address {
    padding-left: 1rem;
    padding-right: 1rem;
    border: 1px solid #ececec;
    border-top: none;
}
</style>



